import React, { useEffect } from "react";
import Wrapper from "./components/wrapper";
import FlipView from "./components/flipView";
import ScoresResultView from "./components/scoresResultView";
import { connect } from "react-redux";
import _ from "lodash";
import FlipModal from "./components/flipModal";

const DoneWith2020 = (props) => {
  let roomData = _.get(props, "gameReducer");
  let gameData = _.get(props, "paramsReducer");
  let status = _.get(roomData, "roomObj.game_state.status");
  return (
    <Wrapper>
      {roomData &&
        roomData?.roomObj &&
        (status === "Result" || status === "Over") && <ScoresResultView />}
      {roomData &&
        roomData?.roomObj &&
        (status === "Joining" ||
          status === "PrePlay" ||
          status === "Playing" ||
          status === "Reading" ||
          status === "Evaluating") && (
          <FlipView roomData={roomData} gameData={gameData} />
        )}
      {status === "Reading" && <FlipModal />}
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DoneWith2020);
